import { render, staticRenderFns } from "./DepartmentMemberCheckboxListItem.vue?vue&type=template&id=2c6c2781&scoped=true&"
import script from "./DepartmentMemberCheckboxListItem.vue?vue&type=script&lang=js&"
export * from "./DepartmentMemberCheckboxListItem.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentMemberCheckboxListItem.vue?vue&type=style&index=0&id=2c6c2781&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6c2781",
  null
  
)

export default component.exports